/**
 * EmptyState Component
 *
 * Displays friendly empty state messages with optional actions
 * - Icon support
 * - Title and description
 * - Optional call-to-action button
 * - Size variants
 */

import React from "react";
import PropTypes from "prop-types";
import "./EmptyState.scss";

export const EmptyState = ({
  icon,
  title = "No data",
  description,
  action,
  size = "medium",
  className = "",
}) => {
  const emptyStateClasses = ["empty-state", `empty-state--${size}`, className]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={emptyStateClasses}>
      {icon && <div className="empty-state__icon">{icon}</div>}
      <h3 className="empty-state__title">{title}</h3>
      {description && <p className="empty-state__description">{description}</p>}
      {action && <div className="empty-state__action">{action}</div>}
    </div>
  );
};

EmptyState.propTypes = {
  icon: PropTypes.node,
  title: PropTypes.string,
  description: PropTypes.string,
  action: PropTypes.node,
  size: PropTypes.oneOf(["small", "medium", "large"]),
  className: PropTypes.string,
};

export default EmptyState;
